export const CATEGORY_ICONS: Record<string, string> = {
  'Food': '🍕',
  'Transport': '🚗',
  'Shopping': '🛍️',
  'Fun': '🎬',
  'Health': '💊',
  'Housing': '🏠',
  'Bills/Other': '📄',
  'Coffee': '☕',
  'Utilities': '💡',
};

export const getCategoryIcon = (category: string): string => {
  return CATEGORY_ICONS[category] || '💰';
};
